export default [
  {
    path: 'subscription',
    name: 'offerSubscription',
    children: [
      {
        path: 'duplicate',
        name: 'offerSubscriptionDuplicate',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_ADD',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },

            {
              text: 'offer.subscription.title',
              pln: 1,
              active: true,
            },
            {
              text: 'action.duplicate',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'show',
        name: 'offerSubscriptionShow',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_VIEW',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },

            {
              text: 'offer.subscription.title',
              pln: 1,
              active: true,
            },
            {
              text: 'action.show',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'edit',
        name: 'offerSubscriptionEdit',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_EDIT',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },

            {
              text: 'offer.subscription.title',
              pln: 1,
              active: true,
            },
            {
              text: 'action.edit',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
    ],
  },
]
